<template>
  <v-container>
    <v-row>
      <v-col>
        <v-alert
          type="error"
        >
          You are not permitted to view this page
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ForbiddenView'
}
</script>
